var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = ["disabled", "href", "onClick"];
export default /*#__PURE__*/ _defineComponent(__assign({
    inheritAttrs: false,
}, { __name: 'ELink', props: {
        hrefTo: {},
        activeClasses: { default: '' },
        disabled: { type: Boolean },
        disabledNavigation: { type: Boolean }
    }, emits: ["click"], setup: function (__props, _a) {
        var __emit = _a.emit;
        var emit = __emit;
        var props = __props;
        var isScrollDisabled = function (e) {
            // проверяем открытие ссылки в новой вкладке
            return e.button === 1
                || (e.button === 0
                    && (e.ctrlKey || e.metaKey));
        };
        var onClick = function (e, navigate) {
            // Если отключена кнопка или нажата не левакя кнопка и не правая кнопка
            if (props.disabled || ![0, 1].includes(e.button)) {
                e.preventDefault();
                return;
            }
            if (props.disabledNavigation) {
                e.preventDefault();
                emit('click', e);
                return;
            }
            emit('click', e);
            navigate(e);
            if (!isScrollDisabled(e)) {
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth',
                });
            }
        };
        return function (_ctx, _cache) {
            var _component_router_link = _resolveComponent("router-link");
            return (_ctx.hrefTo)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: _ctx.hrefTo,
                    custom: ""
                }, {
                    default: _withCtx(function (_a) {
                        var href = _a.href, navigate = _a.navigate, isActive = _a.isActive;
                        return [
                            _createElementVNode("a", _mergeProps(_ctx.$attrs, {
                                class: [[
                                        isActive ? _ctx.activeClasses : '',
                                        {
                                            'e-link--active': isActive,
                                        }
                                    ], "e-link"],
                                disabled: _ctx.disabled,
                                href: href,
                                onClick: function ($event) { return (onClick($event, navigate)); }
                            }), [
                                _renderSlot(_ctx.$slots, "default")
                            ], 16, _hoisted_1)
                        ];
                    }),
                    _: 3
                }, 8, ["to"]))
                : _createCommentVNode("", true);
        };
    } }));
